































































































































































































































































































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { TIAN_KONG, DUO_XUAN, DAN_XUAN } from './questionnaire/const'
import AddResurvey from './addResurvey/addResurvey.vue'
import AddMotion from './addResurvey/addMotion.vue'
import HospitalizedInfo from './addResurvey/HospitalizedInfo.vue'
import RevisitApi from '@/api/revisit'
import { RESURVEY, MOTION, NEW_MOTION } from '@/utils/const'
import { hasValue } from '@/utils/util'
import moment from 'moment'
const SHANG_ZHE = '0'
const SHANG_ZHE_JIA_SHU = '1'
const CHE_ZHU = '2'
const UNKNOWN = '2'
const YI_ZHUAN_YUAN = 1
const ICU = 2
const contactList = [
	{
		label: '伤者',
		value: SHANG_ZHE,
		checkKey: 'contactInjury',
		ansKey: 'injuryAnwser',
	},
	{
		label: '伤者家属',
		value: SHANG_ZHE_JIA_SHU,
		checkKey: 'contactFamily',
		ansKey: 'familyAnwser',
	},
	{
		label: '车主',
		value: CHE_ZHU,
		checkKey: 'contactOwner',
		ansKey: 'ownerAnwser',
	},
]

@Component({
	components: {
		AddResurvey,
		AddMotion,
		HospitalizedInfo,
	},
})
export default class PendingForm extends Vue {
	private contactList = contactList
	private SHANG_ZHE = SHANG_ZHE
	private SHANG_ZHE_JIA_SHU = SHANG_ZHE_JIA_SHU
	private CHE_ZHU = CHE_ZHU
	private TIAN_KONG = TIAN_KONG
	private DUO_XUAN = DUO_XUAN
	private DAN_XUAN = DAN_XUAN
	private RESURVEY = RESURVEY
	private MOTION = MOTION
	private NEW_MOTION = NEW_MOTION
	private addForm: any = {}
	private contactChecked = []
	private showResurvey = false
	private showMotion = false
	private showTimePicker = false
	private allRejectPhone = false
	// 问题序号 - 选项关联跳转引发disabled的问题序号数组
	private jumpRangeMap: any = {}
	private addTaskValues: any = null
	private editingAfter = false
	private saving = false
	private latestHosInfo: any = ''
	private addVisible = false

	@Prop({})
	private revisitId!: any

	@Prop({})
	private data!: any

	// 当前详情是否可编辑（回访任务属于当前用户且尚未提交）
	@Prop({ default: true })
	private canEdit!: boolean

	@Watch('data', { immediate: true })
	private onDataChange() {
		if (this.data) {
			const fields: any = {}
			const contactAnsFields: any = {}

			const contactChecked: string[] = []
			contactList.forEach((contact: any) => {
				if (this.contactInfo && this.contactInfo[contact.checkKey] === '1') {
					contactChecked.push(contact.value)
					contactAnsFields[contact.ansKey] = this.contactInfo[contact.ansKey]
				}
			})
			fields.contactChecked =
				contactChecked.length > 0 ? contactChecked : [SHANG_ZHE]

			const questionAns: any[] = []
			fields.questionAns = []
			this.questionList.forEach((question: any, index: number) => {
				questionAns[index] = {}
				const remark: string[] = []
				const checkedOpt: string[] = question.optionList.reduce(
					(arr: any, option: any, index: number) => {
						if (option.checked === '1') {
							arr.push(option.optionId)
						}
						if (option.remark) {
							remark[index] = option.remark
						}
						return arr
					},
					[]
				)
				if (checkedOpt.length > 0) {
					questionAns[index].checkedOpt =
						question.questionType === DAN_XUAN
							? Number(checkedOpt.join(''))
							: checkedOpt
				}
				if (remark.length > 0) {
					questionAns[index].remark =
						question.questionType === TIAN_KONG ? remark.join('') : remark
				}
				fields.questionAns[index] = questionAns[index]
			})

			fields.tagList = this.tagList.reduce((temp: any, tag: any) => {
				if (tag && tag.checked === '1') {
					temp.push(tag.id)
				}
				return temp
			}, [])
			if (this.data.outHospitalDate) {
				this.showTimePicker = true
				fields.outHospitalDate = moment(this.data.outHospitalDate)
			} else {
				this.showTimePicker = false
			}

			this.showResurvey = this.data.canCreateTask === RESURVEY
			this.showMotion = [MOTION, NEW_MOTION].includes(this.data.canCreateTask)
			this.$nextTick(() => {
				const defaultOutHospital = this.canEdit ? '2' : ''
				this.addForm.setFieldsValue({
					outHospital: this.data.outHospital || defaultOutHospital,
					remark: this.data.remark,
					...fields,
				})
				this.$nextTick(() => {
					let hospitalizedTag: number[] = []
					if (this.data.icu === '1') {
						hospitalizedTag.push(ICU)
					}
					if (this.data.transferHospital === '1') {
						hospitalizedTag.push(YI_ZHUAN_YUAN)
					}
					// 在联系对象设置勾选后再赋值
					this.addForm.setFieldsValue({
						...contactAnsFields,
						hospitalizedTag,
					})
					this.setDisabled()
				})
			})
		}
	}

	private get orderId() {
		return this.data.taskInfo && this.data.taskInfo.orderId
	}

	private get contactInfo() {
		return (this.data && this.data.contactInfo) || {}
	}

	private get questionList() {
		return (this.data && this.data.questionList) || []
	}

	private get tagList() {
		return (this.data && this.data.tagList) || []
	}

	private get isFinished() {
		return this.data.taskStatus >= '30'
	}

	private get yesNoList() {
		return this.$store.state.setting.yesNoList.map((item: any) => ({
			label: item.value,
			value: item.key,
		}))
	}

	private get jumpDisabled() {
		let arr: number[] = []
		for (let key in this.jumpRangeMap) {
			arr = arr.concat(this.jumpRangeMap[key])
		}
		return arr
	}

	private getDetail() {
		this.$emit('getDetail')
	}

	private disabledDate(current: any) {
		return current > moment().add(3, 'day')
	}

	private onDateChange(date: any) {
		if (date) {
			const dateDiff = moment()
				.startOf('day')
				.diff(date.startOf('day'), 'days')
			this.showMotion = dateDiff >= 0
		} else {
			this.showMotion = false
		}
	}

	private getLatestHosInfo() {
		this.latestHosInfo = ''
		// 回访完成后再下单直接从后台取最新住院信息
		if (!this.canEdit) {
			this.addVisible = true
			return
		}

		const hospitalizedInfo: any = this.$refs.hospitalizedInfo
		if (hospitalizedInfo) {
			hospitalizedInfo
				.getForm()
				.then((res: any) => {
					const inHospitalList = res.inHospitalList || []
					let latestHosInfo: any = ''
					inHospitalList.forEach((item: any) => {
						if (
							!latestHosInfo.endTime ||
							new Date(item.endTime) >= new Date(latestHosInfo.endTime)
						) {
							latestHosInfo = item
						}
					})
					this.latestHosInfo = latestHosInfo
					this.addVisible = true
				})
				.catch((err: any) => {
					this.$message.error('请输入转院信息后再下单')
				})
		} else {
			this.addVisible = true
		}
	}

	private setDisabled() {
		const checkedValues: string[] = this.addForm.getFieldValue('contactChecked')
		let arr: string[] = []
		contactList.forEach((item: any) => {
			if (checkedValues.includes(item.value)) {
				arr.push(item.ansKey)
			}
		})
		const answers = this.addForm.getFieldsValue(arr)
		this.allRejectPhone = arr.every((key: string) => {
			return answers[key] === '0'
		})

		const outHospital = this.addForm.getFieldValue('outHospital')
		this.$emit('setSucDisabled', this.allRejectPhone || outHospital === UNKNOWN)
		this.$emit(
			'setFailDisabled',
			!this.allRejectPhone && ['1', '0'].includes(outHospital)
		)
	}

	private onAnswerChange() {
		this.$nextTick(() => {
			// 在nextTick中调用 以便getFieldValue取到最新的勾选值
			this.setDisabled()
		})
	}

	private setJumpRangeMap(index: number, option: any) {
		const linkQuestionId = option.linkQuestionId
		if (!hasValue(linkQuestionId)) {
			this.$set(this.jumpRangeMap, index, [])
			return
		}
		const linkQuestionIdx = this.questionList.findIndex(
			(question: any) => question.questionId === linkQuestionId
		)
		if (linkQuestionIdx > index) {
			const idxArr: number[] = []
			const fieldNames: string[] = []

			for (let i = index + 1; i < linkQuestionIdx; i++) {
				idxArr.push(i)
				fieldNames.push(`questionAns[${i}]`)
			}
			this.$set(this.jumpRangeMap, index, idxArr)
			this.addForm.resetFields(fieldNames)
		}
	}

	private onQuestionRadioChange(evt: any, question: any, index: number) {
		const option = question.optionList.find(
			(option: any) => option.optionId === evt.target.value
		)
		this.setJumpRangeMap(index, option)
	}

	private outHospitalChange(checkedValue: any) {
		const checked = checkedValue.target.value

		this.showTimePicker = checked === '1'

		// 选择“否”时，本次未决回访在住院复勘要求时间内，且此时无正在进行或已完成的住院复勘任务，则展示【住院复勘】按钮
		this.showResurvey =
			checked === '0' && this.data.taskInfo && this.data.taskInfo.createReview

		this.showMotion = false
		this.addTaskValues = null

		// 选择“不清楚”【回访成功】按钮置灰不可用
		this.$emit('setSucDisabled', this.allRejectPhone || checked === UNKNOWN)
		this.$emit(
			'setFailDisabled',
			!this.allRejectPhone && ['1', '0'].includes(checked)
		)
	}

	private onTaskSubmit(values: any) {
		this.addTaskValues = values ? { ...values } : values
	}

	// 供父组件使用
	private go2AddTask(resurveyType: string) {
		if (resurveyType === RESURVEY) {
			const addResurvey: any = this.$refs.addResurvey
			if (addResurvey) {
				addResurvey.showModal()
			}
		} else if ([MOTION, NEW_MOTION].includes(resurveyType)) {
			const addMotion: any = this.$refs.addMotion
			if (addMotion) {
				addMotion.showModal()
			}
		}
	}

	private fillRemark() {
		const questionAns = this.addForm.getFieldValue('questionAns')
		let ansArr: string[] = []
		this.questionList.reduce(
			(ansArr: string[], question: any, index: number) => {
				const answer = questionAns[index]

				if ([DUO_XUAN, DAN_XUAN].includes(question.questionType)) {
					const checkedOpt = Array.isArray(answer.checkedOpt)
						? answer.checkedOpt
						: hasValue(answer.checkedOpt)
						? [answer.checkedOpt]
						: []
					const remark = answer.remark
					const currentAnsArr: string[] = []

					if (checkedOpt && checkedOpt.length > 0) {
						question.optionList &&
							question.optionList.forEach((option: any, k: number) => {
								if (checkedOpt.includes(option.optionId)) {
									if (option.optionType === '1') {
										const str = `${option.optionContent || ''}（${remark[k] ||
											''}）`
										currentAnsArr.push(str)
									} else {
										currentAnsArr.push(option.optionContent)
									}
								}
							})
						if (currentAnsArr.length > 0) {
							ansArr.push(currentAnsArr.join('、'))
						}
					}
				} else {
					if (hasValue(answer.remark)) {
						ansArr.push(answer.remark)
					}
				}
				return ansArr
			},
			ansArr
		)

		this.addForm.setFieldsValue({ remark: ansArr.join('；') })
	}

	private cancelRemark() {
		this.addForm.setFieldsValue({
			remark: this.data.remark,
		})
		this.editingAfter = false
	}

	private saveRemark() {
		this.saving = true
		RevisitApi.saveRemark({
			remark: this.addForm.getFieldValue('remark'),
			revisitId: this.revisitId,
		})
			.then(() => {
				this.editingAfter = false
				this.$emit('getDetail')
			})
			.finally(() => {
				this.saving = false
			})
	}

	private notifyInsurance() {
		const remark = this.addForm.getFieldValue('remark')
		if (!(remark && remark.length > 0)) {
			this.$message.error('通知内容不能为空，请确认后再发送')
			return
		}

		this.$confirm({
			title: '提示',
			content: '请确定是否推送备注信息到保险公司案件负责人？',
			onOk: () => {
				return RevisitApi.notifyInsurance(this.revisitId)
					.then((res: any) => {
						this.$message.success('发送成功')
						this.$emit('getDetail')
					})
					.catch(err => {
						console.error('notifyInsurance failed: ', err)
					})
			},
		})
	}

	private getForm(revisitStatus: string) {
		return new Promise((resolve, reject) => {
			this.addForm.validateFieldsAndScroll(async (errors: any, values: any) => {
				if (!errors) {
					// 校验住院情况是否已填写
					const hospitalizedInfo: any = this.$refs.hospitalizedInfo
					if (hospitalizedInfo) {
						try {
							const res = await hospitalizedInfo.getForm()
							values = Object.assign({}, values, res)
							delete values.hosIds
							delete values.hospitalizedTag
						} catch (err) {
							reject(err)
							return
						}
					}
					values.contactInfo = {}
					contactList.forEach((item: any) => {
						values.contactInfo[item.checkKey] =
							values.contactChecked &&
							values.contactChecked.includes(item.value)
								? '1'
								: '0'
						values.contactInfo[item.ansKey] = values[item.ansKey]
						delete values[item.ansKey]
					})
					delete values.contactChecked

					values.questionList = []
					this.questionList.forEach((question: any, index: number) => {
						const answer = values.questionAns[index]
						const optionList: any[] = []

						if ([DUO_XUAN, DAN_XUAN].includes(question.questionType)) {
							const checkedOpt = Array.isArray(answer.checkedOpt)
								? answer.checkedOpt
								: [answer.checkedOpt]
							const remark = answer.remark
							question.optionList &&
								question.optionList.forEach((option: any, k: number) => {
									if (checkedOpt.includes(option.optionId)) {
										if (option.optionType === '1') {
											optionList.push({
												optionId: option.optionId,
												remark: remark[k],
											})
										} else {
											optionList.push({ optionId: option.optionId })
										}
									}
								})
						} else {
							optionList.push({ remark: answer.remark })
						}
						values.questionList[index] = {
							questionId: question.questionId,
							optionList,
						}
						delete values.questionAns[index]
					})
					delete values.questionAns

					values.outHospitalDate =
						values.outHospitalDate &&
						values.outHospitalDate.format('YYYY-MM-DD')
					values.tagList = values.tagList || []
					if (this.showResurvey || this.showMotion) {
						// 需要新建复勘任务
						values.resurveyType = this.showResurvey ? RESURVEY : NEW_MOTION
						values.addTaskValues = this.addTaskValues
							? { ...this.addTaskValues }
							: null
					}
					resolve(values)
				} else {
					reject(errors)
				}
			})
		})
	}

	private created() {
		this.addForm = this.$form.createForm(this)
	}
}
